/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeRosterEditCtrl
 */
angular
  .module("mercury.modules.time.roster")
  .controller(
    "TimeRosterEditCtrl",
    ["Budgets", "dialog", "$scope", "$filter", "$timeout", "$q", "reporttime", "$state", "$stateParams", "TimeLeaveAndUnavailability", "TimeRoles", "TimeRosteredShifts", "Rosters", "TimeStaff", "title", "$window", "userinfo", "TimePayrollAdjustment", "TimeClock", "shiftHelpers", "settings", "features", function (
      Budgets,
      dialog,
      $scope,
      $filter,
      $timeout,
      $q,
      reporttime,
      $state,
      $stateParams,
      TimeLeaveAndUnavailability,
      TimeRoles,
      TimeRosteredShifts,
      Rosters,
      TimeStaff,
      title,
      $window,
      userinfo,
      TimePayrollAdjustment,
      TimeClock,
      shiftHelpers,
      settings,
      features
    ) {
      // In a roster template the report url param holds information about what is
      // being shown. We use this information instead of the reporttime helper as
      // that is tied to the company start day/time which may not match the template
      // start day/time.
      var reportStateParams = $stateParams.report
        ? JSON.parse($stateParams.report)
        : {};

      // Set up 'global' roster scope variables that will be used throughout the
      // child controllers / templates of the roster editor. These differ in what
      // they hold based on whether the user is viewing a roster or a roster
      // template.
      if ($stateParams.templateId == null) {
        $scope.isTemplate = false;
        $scope.templateId = null;
        // We default to the week report type here because if the user arrives from
        // a page where they haven't specified a report type the standard behaviour
        // is to default to the 'day' report type. This then causes issues with
        // displaying the grid - it starts on the current day instead of the start
        // day based on the company preference.
        $scope.viewStartDateTime = reporttime.start("week");
        $scope.viewEndDateTime = reporttime.end("week");
        title.set("Roster Editor");
      } else {
        $scope.templateId = $stateParams.templateId;
        $scope.isTemplate = true;
        $scope.viewStartDateTime =
          reportStateParams.start || reporttime.start("week");
        $scope.viewEndDateTime =
          reportStateParams.end || reporttime.end("week");
        $scope.isUpdatingTemplateName = false;
        title.set("Roster Template Editor");
      }

      reporttime.defaultType = "week";
      reporttime.setAllowedTypes(["day", "week"]);

      $scope.filter = null;
      $scope.reportType = $scope.isTemplate
        ? reportStateParams.period || "week"
        : reporttime.reportType();
      $scope.rostersCount = 0;

      $scope.salaryPermission = userinfo.companyHasPermission("Salary");
      $scope.currentRosters = [];
      $scope.publishButtonText = "Publish";
      $scope.publishButtonClass = "green-button";
      $scope.publishedRosterExists = false;

      $scope.staff = [];
      $scope.staffById = {};

      $scope.unavailabilityVisible = true;
      $scope.leaveRequestsVisible = true;

      $scope.toggleUnavailability = function () {
        $scope.unavailabilityVisible = !$scope.unavailabilityVisible;
      }

      $scope.toggleLeaveRequests = function () {
        $scope.leaveRequestsVisible = !$scope.leaveRequestsVisible;
      }

      $scope.leaveRequestsFeatureEnabled = false;
      features.isEnabled('alpha')
        .then(function(isAlpha) {
          $scope.leaveRequestsFeatureEnabled = isAlpha;
        });

      /**
       * Function used to determine if a given date should allow roster editing or
       * not. Called from the child cellday/cellweek directives.
       * @param {*} date
       * @returns
       */
      $scope.disableCell = function (date) {
        var cellIsDisabled = false;
        var currentDay = moment(date);
        angular.forEach($scope.currentRosters, function (currentRoster) {
          if (
            currentDay >= moment(currentRoster.startDateTime) &&
            currentDay <= moment(currentRoster.endDateTime)
          ) {
            if (currentRoster.datestampLocked != null) {
              cellIsDisabled = true;
            }
          }
        });

        return cellIsDisabled;
      };

      /**
       * Helper to determine if a given datetime is within the date range being used
       * to display the current view.
       * @param {*} dateTimeToTest
       * @returns
       */
      $scope.isInViewDateRange = function (dateTimeToTest) {
        const toTest = moment(dateTimeToTest);
        return (
          toTest.isSameOrAfter($scope.viewStartDateTime) &&
          toTest.isBefore($scope.viewEndDateTime)
        );
      };

      $scope.currentRosters = [];

      const fromDate = $scope.isTemplate ? undefined : moment($scope.viewStartDateTime).format('YYYY-MM-DD');
      const unavailabilityType = $scope.isTemplate ? 'Weekly' : undefined
      $scope.loaderPromise = $q
        .all({
          staff: TimeStaff.getAllActive(
            moment($scope.viewStartDateTime).mEndOf("week").format()
          ),
          roles: TimeRoles.getAll(),
          rosteredShifts: $scope.isTemplate
            ? TimeRosteredShifts.getAllByRosterId($stateParams.templateId)
            : TimeRosteredShifts.getAllForWeek(reporttime.time()),
          budgets: userinfo.companyHasPermission("Report")
            ? Budgets.getAll($scope.viewStartDateTime, $scope.viewEndDateTime)
            : $q.when([]),
          rules: TimePayrollAdjustment.getAllActive(),
          unavailability: TimeLeaveAndUnavailability.getAllUnavailabilityRecords(
            fromDate, unavailabilityType
          ),
          leaveRequests: !$scope.isTemplate ? TimeLeaveAndUnavailability.getAllLeaveRequests(
            fromDate 
          ) : [],
          leaveTypes: !$scope.isTemplate ? TimeLeaveAndUnavailability.getAllLeaveTypes() : []
        })
        .then(function (result) {

          // This then block is to know how many rosters are we displaying within the selected date range and also
          // getting each roster to have more details and be able to know if they are locked or published
          // It will help us to go through the right flow when we click on the Publish button - if there is
          // only 1 roster then we redirect to the publish page but if there are 2 rosters then we display a
          // dialog with a list of rosters and we can choose which one we want to publish or unlock
          var rosterPromises = [];
          var currentRostersIds = [];

          if ($scope.isTemplate) {
            rosterPromises.push(
              Rosters.getById($stateParams.templateId).then(function (
                rosterResult
              ) {
                $scope.currentRosters.push(rosterResult);
                $scope.templateName = rosterResult.templateName;

                $scope.isStartDay = moment($scope.viewStartDateTime).isSame(
                  moment($scope.currentRosters[0].startDateTime)
                );
                $scope.isEndDay = moment($scope.viewEndDateTime).isSame(
                  moment($scope.currentRosters[0].endDateTime)
                );

                $scope.templateStartDay = moment(
                  $scope.currentRosters[0].startDateTime
                );
                $scope.templateEndDay = moment(
                  $scope.currentRosters[0].endDateTime
                );
              })
            );
          } else {
            angular.forEach(result.rosteredShifts, function (rosteredShift) {
              if (!currentRostersIds.includes(rosteredShift.rosterId)) {
                currentRostersIds.push(rosteredShift.rosterId);
                $scope.rostersCount = $scope.rostersCount + 1;

                rosterPromises.push(
                  Rosters.getById(rosteredShift.rosterId, false).then(function (
                    rosterResult
                  ) {
                    if (rosterResult.datestampPublished != null) {
                      $scope.publishedRosterExists = true;
                    }
                    $scope.currentRosters.push(rosterResult);
                  })
                );
              }
            });
          }

          //Don't wait on all promises because that will cause a delay in the frontend
          //because it is not linked to the main loader
          return $q.all(rosterPromises).then(function () {
            if ($scope.currentRosters.length === 1) {
              if (
                $scope.currentRosters[0].datestampPublished != null &&
                $scope.currentRosters[0].datestampLocked == null
              ) {
                $scope.publishButtonText = "Published";
                $scope.publishButtonClass = "locked-roster";
              } else if (
                $scope.currentRosters[0].datestampPublished != null &&
                $scope.currentRosters[0].datestampLocked != null
              ) {
                $scope.publishButtonText = "Published & Locked";
                $scope.publishButtonClass = "locked-roster";
              }
            } else if ($scope.reportType == "day") {
              for (var i = 0; i < $scope.currentRosters.length; i++) {
                var currentDay = moment($scope.viewStartDateTime);
                if (
                  currentDay >=
                  moment($scope.currentRosters[i].startDateTime) &&
                  currentDay <= moment($scope.currentRosters[i].endDateTime)
                ) {
                  if (
                    $scope.currentRosters[i].datestampPublished != null &&
                    $scope.currentRosters[i].datestampLocked == null
                  ) {
                    $scope.publishButtonText = "Published";
                    $scope.publishButtonClass = "locked-roster";
                    break;
                  } else if (
                    $scope.currentRosters[i].datestampPublished != null &&
                    $scope.currentRosters[i].datestampLocked != null
                  ) {
                    $scope.publishButtonText = "Published & Locked";
                    $scope.publishButtonClass = "locked-roster";
                    break;
                  }
                }
              }
            }

            angular.forEach($scope.currentRosters, function (currentRoster) {
              angular.forEach(result.rosteredShifts, function (rosteredShift) {
                if (rosteredShift.rosterId === currentRoster.id) {
                  rosteredShift.datestampLocked = currentRoster.datestampLocked;
                  rosteredShift.datestampPublished =
                    currentRoster.datestampPublished;
                }
              });
            });

            return result;
          });
        });

      $scope.loaderPromise.then(function (result) {
        angular.forEach(result.rosteredShifts, function (rosteredShift) {
          var staff = $filter("filter")(result.staff, {
            id: rosteredShift.staffMemberId,
          });

          var tooltipText = null;
          if (rosteredShift.staffMemberDatestampDeleted != null) {
            tooltipText = "This employee is not currently active";
          } else if (!rosteredShift.staffMemberShowInRoster) {
            tooltipText =
              "This employee is currently set as not visible on the roster";
          }

          if (staff.length === 0) {
            result.staff.push({
              id: rosteredShift.staffMemberId,
              name:
                rosteredShift.staffMemberFirstName +
                (rosteredShift.staffMemberLastName
                  ? " " + rosteredShift.staffMemberLastName
                  : ""),
              defaultMemberRoleRoleName: rosteredShift.roleName,
              defaultMemberRoleRoleId: rosteredShift.roleId,
            });
          }

          angular.forEach(result.staff, function (member) {
            //We don't want to display the reassign shifts functionality if there is a published roster in the date range displayed
            if (
              !$scope.publishedRosterExists &&
              rosteredShift.staffMemberId == member.id
            ) {
              member.tooltipText = tooltipText;
              member.shouldReassignShifts =
                !member.showInRoster ||
                rosteredShift.staffMemberDatestampDeleted != null;
            }
          });
        });

        // Remove staff members who don't have a rostered shift and meet the specified conditions
        if ($scope.isTemplate) {
          result.staff = result.staff.filter(function (member) {
            const hasRosteredShift = result.rosteredShifts.some(function (rosteredShift) {
              return rosteredShift.staffMemberId === member.id;
            });

            // Keep staff with rostered shifts or those with showInRoster = true and datestampDeleted == null
            return (
              hasRosteredShift ||
              (member.showInRoster && member.datestampDeleted === null)
            );
          });
        }

        $scope.rosteredShifts = result.rosteredShifts;

        $scope.staff = $filter("orderBy")(result.staff, "name");
        $scope.staffById = result.staff.reduce((all, staffMember) => {
          all[staffMember.id] = staffMember;
          return all;
        }, {});
        $scope.roles = result.roles;
        $scope.budgets = result.budgets;
        $scope.rules = result.rules;

        const approvedAndRequestedUnavailability = result.unavailability.filter(record =>
          ['Approved', 'Requested'].includes(record.status)
        );

        const approvedAndRequestedLeave = result.leaveRequests
        .filter(leave => ['Approved', 'Requested'].includes(leave.status))
        .map(leave => {
            const leaveType = result.leaveTypes.find(type => type.id === leave.leaveTypeId);
            return Object.assign({}, leave, { type: leaveType ? leaveType.name : undefined });
        });

        $scope.unavailability = $scope.isTemplate ? getCurrentUnavailabilies(approvedAndRequestedUnavailability) : approvedAndRequestedUnavailability;
        $scope.leaveRequests = approvedAndRequestedLeave;

        $scope.totalBudget = 0;
        angular.forEach(result.budgets, function (budget) {
          $scope.totalBudget += budget.amount / (budget.salesTax + 1);
        });

        // used for calculating costs in the input payrate dialog
        angular.forEach($scope.rosteredShifts, function (rosteredShift) {
          rosteredShift.lengthUnrounded = TimeClock.getClockinLengthUnrounded(
            rosteredShift.clockoutTime,
            rosteredShift.clockinTime
          );
        });

        updateMemberTotals();

        jQuery(".role-filter-outer").appendTo(".filter-wrapper");
      });

      /**
       * Is a role to be displayed based on the role filter.
       *
       * @returns {Boolean} true if is shown else false
       */
      $scope.isRoleShown = function (roleId) {
        return (
          $scope.filter === null || typeof $scope.filter[roleId] != "undefined"
        );
      };

      /**
       * Handle adding a new shift.
       * @param {*} rosteredShift - newly added shift data
       */
      $scope.baseAddShift = function (rosteredShift) {
        // Give the roster a tempId which we can use to find its index once the save completes.
        // Also because the rosters are tracked by id on the ngRepeats, we need an id set
        rosteredShift.id = new Date().valueOf() + "/" + $scope.rosteredShifts.length;
        rosteredShift.saving = true;
        $scope.rosteredShifts.push(rosteredShift);

        return Rosters.createShift(rosteredShift)
          .then(function (createdRosteredShift) {
            // Ensure the roster is in currentRosters
            const roster = $scope.currentRosters.find(function (roster) {
              return roster.id === createdRosteredShift.rosterId;
            });

            if (!roster) {
              return Rosters.getById(createdRosteredShift.rosterId).then(function (createdRoster) {
                $scope.currentRosters.push(createdRoster);
                $scope.rostersCount = $scope.rostersCount + 1;
                return createdRosteredShift;
              });
            }

            return createdRosteredShift;
          })
          .then(function (createdRosteredShift) {
            // Replace the temp shift with the created one. 
            // This is only needed for HourlyRate shifts because for Salary ones we need to 
            // get them from the API as adding a new shift would affect the hourly rate of 
            // the other staff member shifts
            if(rosteredShift.remunerationType === 'HourlyRate') {
              $scope.rosteredShifts = $scope.rosteredShifts.map(s =>
                s.id === rosteredShift.id ? createdRosteredShift : s
              );

              return [];
            }

            return $scope.isTemplate
            ? TimeRosteredShifts.getAllByRosterId($stateParams.templateId, [createdRosteredShift.staffMemberId])
            : TimeRosteredShifts.getAllForWeek(reporttime.time(), [createdRosteredShift.staffMemberId])
          })
          .then(function (rosteredShiftsForStaffMembers) {
            mergeRosteredShiftsForStaffMembers(rosteredShiftsForStaffMembers);
            updateMemberTotals();
          });
      };

      /**
       * Handle updating a shift.
       * @param {*} rosteredShift - newly updated shift data 
       */
      $scope.baseUpdateShift = function (rosteredShift) {
        angular.forEach($scope.rosteredShifts, function (existingRosteredShift) {
          if (existingRosteredShift.id == rosteredShift.id) {
            existingRosteredShift.saving = true;
          }
        });

        return TimeRosteredShifts.update(rosteredShift)
        .then(function (updatedRosteredShift) {
          const staffMemberIds = [updatedRosteredShift.staffMemberId]
          
          // If the rostered shift is a HourlyRate shift or we are not updating 
          // the clockin/out times, just update it in place
          if (updatedRosteredShift.remunerationType == rosteredShift.remunerationType && 
            updatedRosteredShift.remunerationType === 'HourlyRate') {
           
              angular.forEach($scope.rosteredShifts, function (existingRosteredShift, index) {
                if (updatedRosteredShift.id === existingRosteredShift.id) {
                  $scope.rosteredShifts.splice(index, 1, updatedRosteredShift)
                }
              });

            if (!rosteredShift.originalStaffMemberId) {
              return [];
            }
          }

          // Otherwise, remove all shifts for this staff member and fetch the latest
          if(rosteredShift.originalStaffMemberId) {
            staffMemberIds.push(rosteredShift.originalStaffMemberId)
          }

          return $scope.isTemplate
            ? TimeRosteredShifts.getAllByRosterId($stateParams.templateId, staffMemberIds)
            : TimeRosteredShifts.getAllForWeek(reporttime.time(), staffMemberIds)
        })
        .then(function (rosteredShiftsForStaffMembers) {
          mergeRosteredShiftsForStaffMembers(rosteredShiftsForStaffMembers);
          updateMemberTotals();
        });

      };

      $scope.baseDeleteShift = function (rosteredShift) {
        angular.forEach($scope.rosteredShifts, function (existingRosteredShift) {
          if (existingRosteredShift.id == rosteredShift.id) {
            existingRosteredShift.saving = true;
          }
        });
        
        const staffMemberIds = [rosteredShift.staffMemberId];

        return TimeRosteredShifts.remove(rosteredShift)
          .then(() => {
            // If the rostered shift is a HourlyRate shift, we just remove it from the list
            // and update the member totals
            if(rosteredShift.remunerationType === 'HourlyRate') {
              $scope.rosteredShifts = $scope.rosteredShifts.filter(i => i.id !== rosteredShift.id);
              return [];
            }

            // Otherwise we need to get all the shifts for the staff member and update the rostered shifts
            // list with the latest ones, so we can update the member totals
            
            return $scope.isTemplate
              ? TimeRosteredShifts.getAllByRosterId($stateParams.templateId, staffMemberIds)
              : TimeRosteredShifts.getAllForWeek(reporttime.time(), staffMemberIds)
          })
          .then((rosteredShiftsForStaffMembers) => {
            mergeRosteredShiftsForStaffMembers(rosteredShiftsForStaffMembers);
            updateMemberTotals();
          });
      };

      $scope.filterUpdated = function (newFilter) {
        $scope.filter = newFilter;

        updateMemberTotals();
      };

      $scope.showShiftEditorDialog = function (data) {
        // The shift editor dialog operates in a 'clean' (isolated) scope, this
        // ensures that alterations to the data in the dialog don't mess up the
        // datamodel used by the main roster view behind it.
        //
        // Here we create the dialog scope and set some properties on it so they
        // can be accessed by the dialog controller.
        const dialogScope = $scope.$new(true);
        dialogScope.isTemplate = $scope.isTemplate;
        dialogScope.templateId = $scope.templateId;
        dialogScope.reportType = $scope.reportType;
        dialogScope.viewStartDateTime = $scope.viewStartDateTime;
        dialogScope.viewEndDateDateTime = $scope.viewEndDateTime;

        return dialog.open({
          templateUrl: "modules/time/roster/editshiftdialog.tpl.html",
          controller: "TimeRosterEditShiftCtrl",
          scope: dialogScope,
          resolve: {
            data: function () {
              // We deep copy the data object to get fully detached data to
              // pass through to the dialog scope. Otherwise we end up with
              // changes in the dialog inadvertently affecting the main view.
              return angular.copy(data);
            },
          },
        });
      };

      $scope.navigateToCopyRoster = function () {
        var currentRosterReportParam = JSON.stringify({
          time: $scope.viewStartDateTime,
          type: "week",
        });
        $state.go(
          "Time.RosterCopy",
          {
            start: $scope.viewStartDateTime,
            end: $scope.viewEndDateTime,
            report: currentRosterReportParam,
          },
          { reload: true }
        );
      };

      $scope.showShareDialog = function () {
        dialog.open({
          templateUrl: "modules/time/roster/sharedialog.tpl.html",
          controller: "TimeRosterSettingsCtrl",
        });
      };

      $scope.printByStaff = function () {
        var roleFilter = null;
        if ($scope.filter !== null) {
          roleFilter = Object.keys($scope.filter).join(",");
        }

        TimeRosteredShifts.printByStaff(
          $scope.viewStartDateTime,
          $scope.viewEndDateTime,
          roleFilter
        ).then(function (result) {
          $window.open(result.location);
        });
      };

      $scope.printByRole = function () {
        var roleFilter = null;
        if ($scope.filter !== null) {
          roleFilter = Object.keys($scope.filter).join(",");
        }

        TimeRosteredShifts.printByRole(
          $scope.viewStartDateTime,
          $scope.viewEndDateTime,
          roleFilter
        ).then(function (result) {
          $window.open(result.location);
        });
      };

      $scope.publishAndLockRosters = function () {
        if ($scope.rostersCount == 1) {
          if ($scope.currentRosters[0].datestampLocked != null) {
            dialog.open({
              templateUrl: "modules/time/roster/unlockRoster.tpl.html",
              controller: "TimeRosterUnlockRosterCtrl",
              size: "md",
              scope: $scope,
              resolve: {
                roster: $scope.currentRosters[0],
              },
            });
          } else {
            $state.go(
              "Time.RosterPublish",
              {
                rosterId: $scope.currentRosters[0].id,
                start: $scope.viewStartDateTime,
                end: $scope.viewEndDateTime,
              },
              { reload: true }
            );
          }
        } else {
          dialog.open({
            templateUrl: "modules/time/roster/publishAndLockRosters.tpl.html",
            controller: "TimeRosterPublishAndLockRostersCtrl",
            size: "md",
            scope: $scope,
          });
        }
      };

      $scope.updateTemplateName = function () {
        const currentRoster = $scope.currentRosters[0];
        const newTemplateName = $scope.currentRosters[0].templateName;
        $scope.toggleUpdateTemplateName(false);

        //If the value hasn't change then we don't want to trigger the onBlur function
        if (newTemplateName === $scope.templateName) {
          return;
        }

        if (newTemplateName != "" && newTemplateName != null) {
          // Create a new object that clones the current roster, but with the
          // template name updated.
          var updatedRoster = Object.assign({}, currentRoster, { templateName: newTemplateName });

          $scope.updatingTemplateName = Rosters.updateRoster(
            updatedRoster
          );

          $scope.updatingTemplateName
            .then(function (result) {
              $scope.templateName = result.templateName;
              $scope.updatingTemplateName = false;
            })
            .catch(function () {
              $scope.updatingTemplateName = false;
            });
        }
      };

      $scope.toggleUpdateTemplateName = function (enable) {
        $scope.isUpdatingTemplateName = enable;
      };

      /**
       * Save the current weeks roster as a template.
       *
       * Note that if the user is viewing a day and copies the roster, shifts
       * for the entire week are copied across to the new template.
       */
      $scope.saveRosterAsTemplate = function () {

        // We need to get the start of the current week here because if the user
        // were in the day view we'd otherwise be asking to copy a roster with
        // an incorrect start date (except for the edge case of them being in
        // day view on the company start day).
        const rosterWeekStartMoment = moment($scope.viewStartDateTime).mStartOf('week')
        // The end date from the users perspective is 6 days after the start date.
        // In many places we'd wind forward by 7 days, but we're actually wanting
        // the last day within the week here - not the start date of the next week.
        const rosterWeekEndMoment = rosterWeekStartMoment.clone().add(6, 'days');

        const newTemplateName =
          rosterWeekStartMoment.format(
            settings.dateFormats.mediumDate
          ) +
          " - " +
          rosterWeekEndMoment.format(
            settings.dateFormats.mediumDate
          );

        // Actaully call the API to create the new template now.
        $scope.loaderPromise = Rosters.saveRosterAsTemplate(
          rosterWeekStartMoment.toISOString(),
          newTemplateName
        );

        // Now redirect the user to the newly created template page.
        $scope.loaderPromise.then(function (result) {
          $state.go(
            "Time.EditTemplate",
            { templateId: result.id },
            { reload: true }
          );
        });
      };

      $scope.deactivateTemplate = function () {
        $scope.deactivatingTemplate = Rosters.deactivateTemplate(
          $scope.templateId,
          $scope.templateName
        );
        $scope.deactivatingTemplate
          .then(function () {
            $state.go("Time.RosterTemplates", { reload: true });
          })
          .catch(function () {
            $scope.deactivatingTemplate = false;
          });
      };

      $scope.useTemplate = function () {
        $state.go(
          "Time.RosterCopy",
          { templateId: $scope.templateId },
          { reload: true }
        );
      };

      $scope.restoreTemplate = function () {
        $scope.restoringTemplate = Rosters.restoreTemplate(
          $scope.templateId,
          $scope.templateName
        );
        $scope.restoringTemplate
          .then(function (result) {
            // We can assume currentRosters[0] is where the template roster object is stored
            // because when using templates, currentRosters array only has one element
            $scope.currentRosters[0] = result;
          })
          .catch(function (result) {
            $scope.restoringTemplate = false;
          });
      };

      /**
       * Function to calculate the staff members hours and pay totals for the view.
       */
      function updateMemberTotals() {
        $scope.memberTotals = {};

        angular.forEach($scope.rosteredShifts, function (rosteredShift) {
          // Check if the rostered shift is in the view date range
          if (!$scope.isInViewDateRange(rosteredShift.clockinTime)) {
            return;
          }

          // Only add the hours that match the filter exactly. If the staff matches
          // the filter but this shift doesn't, don't add this to the totals.
          if ($scope.isRoleShown(rosteredShift.roleId)) {
            if (!$scope.memberTotals[rosteredShift.staffMemberId]) {
              $scope.memberTotals[rosteredShift.staffMemberId] = {
                hours: 0,
                pay: 0,
              };
            }

            // Calculate the total unpaid break duration using the helper function
            var totalUnpaidBreakDuration =
              shiftHelpers.calculateTotalUnpaidBreakDuration(rosteredShift);

            // Calculate hours worked and pay
            var hoursWorked =
              moment(rosteredShift.clockoutTime).diff(
                moment(rosteredShift.clockinTime),
                "minutes"
              ) / 60;
            // Remove unpaid break duration from hours worked
            hoursWorked =
              hoursWorked >= totalUnpaidBreakDuration
                ? hoursWorked - totalUnpaidBreakDuration
                : hoursWorked;

            $scope.memberTotals[rosteredShift.staffMemberId].hours += hoursWorked;
            $scope.memberTotals[rosteredShift.staffMemberId].pay +=
              hoursWorked * rosteredShift.adjustedHourlyRate;
          }
        });

        angular.forEach($scope.staff, function (member) {
          if (
            $scope.isRoleShown(member.defaultMemberRoleRoleId) &&
            !$scope.memberTotals[member.id] &&
            member.showInRoster
          ) {
            $scope.memberTotals[member.id] = {
              hours: 0,
              pay: 0,
            };
          }
        });

        // Set the roster totals.
        $scope.totalHours = $filter("sumof")($scope.memberTotals, "hours");
        $scope.totalPay = $filter("sumof")($scope.memberTotals, "pay");

        $scope.$broadcast("totalsChanged");

        $scope.staffRatio = $scope.totalBudget
          ? ($scope.totalPay / $scope.totalBudget) * 100
          : 0;
      }

      function getCurrentUnavailabilies(records) {
        const today = moment()

        return records.filter(record => {
            const fromDate = moment(record.from);

            //We want all the records that are before today
            const condition1 = fromDate.isSameOrBefore(today);
            //We want all records that end after today or has no end date
            const condition2 = record.to ? moment(record.to).isAfter(today) : true

            return condition1 && condition2;
        });
      }

      function mergeRosteredShiftsForStaffMembers(rosteredShiftsForStaffMembers) {
        if (!rosteredShiftsForStaffMembers || !rosteredShiftsForStaffMembers.length) return;
        // Build a map of new shifts by id for fast lookup
        var newShiftsById = {};
        angular.forEach(rosteredShiftsForStaffMembers, function(shift) {
          newShiftsById[shift.id] = shift;
        });
        // Get all staffMemberIds involved
        var staffMemberIds = rosteredShiftsForStaffMembers.map(function(shift) { return shift.staffMemberId; });
        // Splice in new shifts, remove obsolete ones
        for (var i = $scope.rosteredShifts.length - 1; i >= 0; i--) {
          var shift = $scope.rosteredShifts[i];
          if (staffMemberIds.indexOf(shift.staffMemberId) !== -1) {
            if (newShiftsById[shift.id]) {
              // Replace in place
              $scope.rosteredShifts.splice(i, 1, newShiftsById[shift.id]);
              delete newShiftsById[shift.id];
            } else {
              // Remove obsolete
              $scope.rosteredShifts.splice(i, 1);
            }
          }
        }
        // Add any new shift that is not already in $scope.rosteredShifts
        angular.forEach(newShiftsById, function(shift) {
          $scope.rosteredShifts.push(shift);
        });
      }

    }]
  );
